import React, { memo, Fragment } from 'react';
import { LatexComponent } from 'components/HHQComponents'; // đảm bảo import đúng alias của bạn
import { TestDetailQuizModel } from 'models/test-detail.model';
import './index.css';
interface PropTypes {
    question: TestDetailQuizModel;
    showTruth: boolean;
}
const TCHDienVaoChoTrongComponent: React.FC<PropTypes> = ({ question, showTruth }) => {
  const correctAnswers = (question.testQuestionAnswers || [])
    .filter(ans => ans.isCorrect)
    .map(ans => (ans?.answer || '').replace(/ /g, '').toLowerCase());

  const correctAnswersRaw = (question.testQuestionAnswers || [])
    .filter(ans => ans.isCorrect)
    .map(ans => ans?.answer || '')
    .join(', ');

  const userAnswer =
    (question.userAnswer?.length ? question.userAnswer[0] : '')?.replace(/ /g, '').toLowerCase();

  let suggestion = (question.testQuestionAnswers || [])
    .filter(ans => !ans.isCorrect && ans.comment)
    .map(ans => ans.comment)
    .join(', ');

  // Nếu trả lời đúng thì lấy comment từ đáp án đúng
  if (correctAnswers.includes(userAnswer)) {
    suggestion = (question.testQuestionAnswers || [])
      .filter(ans => ans.isCorrect && ans.comment)
      .map(ans => ans.comment)
      .join(', ');
  }

  return (
    <Fragment>
      <div className="dien-vao-cho-trong" />
      <div className="grid font-size-14">
        {showTruth && !correctAnswers.includes(userAnswer) && (
          <div className="col-12">
            <LatexComponent>
              <>
                <span>
                  <i className="pi pi-check-square text-green-400 text-bold mr-2 font-size-14" />
                  Đáp án đúng:
                </span>
                <span
                  className="ml-1"
                  dangerouslySetInnerHTML={{ __html: correctAnswersRaw || '' }}
                />
              </>
            </LatexComponent>
          </div>
        )}

        {suggestion && (
          <div className="col-12">
            <span className="mr-1 font-size-14">Gợi ý:</span>
            <LatexComponent>
              <span
                dangerouslySetInnerHTML={{
                  __html: suggestion || 'Không có câu trả lời',
                }}
              />
            </LatexComponent>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default memo(TCHDienVaoChoTrongComponent);
